import { trpc } from '@/shared/api';

/** 접수 뒤 그 주문의 문의 목록(작성 가능 여부 포함)을 다시 불러오게 한다. */
export const useInvalidateMyOrderInquiries = (): ((orderId: string) => Promise<void>) => {
  const utils = trpc.useUtils();
  return (orderId) => utils.myOrderInquiries.listByOrder.invalidate({ orderId });
};
